import { useState } from "react";

type CookiePreference = "accepted" | "declined" | null;

const COOKIE_STORAGE_KEY = "cookies";

const getCookiePreference = (): CookiePreference => {
  const stored = localStorage.getItem(COOKIE_STORAGE_KEY);
  if (stored === "accepted" || stored === "declined") {
    return stored;
  }
  return null;
};

export const useCookies = () => {
  const [preference, setPreference] = useState<CookiePreference>(() =>
    getCookiePreference(),
  );

  const handlePreferenceChange = (newPreference: "accepted" | "declined") => {
    setPreference(newPreference);
    localStorage.setItem(COOKIE_STORAGE_KEY, newPreference);
  };

  return {
    preference,
    handlePreferenceChange,
  };
};
